const radiansToDegrees = (radians) => (radians * 180) / Math.PI;

export { radiansToDegrees };
